// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__2XCTk","active":"Navbar_active__d4rIh","link":"Navbar_link__K1+M-"};